const defaultState = {
  shumaData: [],
  loading: false,
  error: false,
  errorMessage: null
};

export const actionTypes = {
  inspectionDetailsFetched: 'INSPECTION_DETAILS_FETCHED',
  catchError: 'CATCH_ERROR'
};

export const inspectionDetailsReducer = (state= defaultState, action) => {
  switch (action.type) {
    case actionTypes.inspectionDetailsFetched: {
      const {shumaData} = action.payload;
      return {
        ...state,
        shumaData,
        loading: false,
        error: false,
        errorMessage: null
      };
    }
    case actionTypes.catchError: {
      const error = `INSPECTION DETAILS: ${action.payload.error}`;
      return {...state, error};
    }
    default: return state;
  }
};

export const actions = {
  inspectionDetailsFetched: (data) => ({
    type: actionTypes.inspectionDetailsFetched,
    payload: data
  }),
  catchError: (error) => ({
    type: actionTypes.catchError,
    payload: {error}
  }),
};
